import React from 'react';
import { Route, DefaultRoute, NotFoundRoute, Redirect } from 'react-router';
import App from 'components/App';
import Home from 'pages/Home';
import Consist from 'pages/Consist';
import Source from 'pages/Source';
// import Quality from 'pages/Quality';
import Faq from 'pages/Faq';
import Form from 'pages/Form';
import City from 'pages/City';
import { Contest, ContestDetail } from 'pages/Contest';
import Page404 from 'pages/Page404';

const routes = (
  <Route handler={App} path="/">
    <DefaultRoute handler={Home} />
    <Route handler={Consist} path="original" />
    <Route handler={Source} path="source" />
    {/* <Route handler={Quality} path="journey" /> */}
    <Route handler={Faq} path="faq" />
    <Route handler={Form} path="form" />
    <Route handler={City} path="city" />
    <Route
      handler={ContestDetail}
      name="winnersDetail"
      path="winners/:number"
    />
    <Route name="winners" handler={Contest} path="winners" />
    <NotFoundRoute name="404" handler={Page404} />
  </Route>
);

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js